import React from 'react';
import className from 'classnames';
import moment from 'moment';
import {get} from 'lodash';
import axios from 'axios';

import {
  canBan,
} from '../lib/policies';

import {
  CSRF_TOKEN,
  requestCallback,
} from '../lib/helpers';

import {
  useCheckIds,
  useModal,
} from '../hooks';

import LiftBanModal from './LiftBanModal';
import TableHeader from './TableHeader';
import Modal from './Modal'

const BannedIpsList = ({
  ips = [],
  total = 0,
}) => {
  const {
    checkIds,
    renderCheckBox, renderCheckBoxForCheckAll,
  } = useCheckIds({
    data: ips,
  })

  const [
    modal,
    modalSet,
  ] = useModal({
    keyboardBindings: true,
  })

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Banned IP addresses list</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} ips</p>
        </div>

        <div className='MainHeader__right'>
          <a
            className='MainHeader__right__a MainHeader__right__a--bright-blue'
            onClick={() => {
              modalSet(true)
            }}
          >
            Add ban IP
          </a>
        </div>
      </div>

      <div className='TableChecker'>
        {renderCheckBoxForCheckAll()}
      </div>

      <div className='Table Table--banned-ips-list'>
        {(() => {
          const columnHeaders = [
            {
              label: '',
            },
            {
              label: 'ID',
              sortKey: 'id',
            },
            {
              label: 'IP address',
            },
            {
              label: 'Admin',
            },
            {
              label: 'Created at',
              sortKey: 'created_at',
            },
            {
              label: 'Manage',
            },
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {ips.map((ip) => (
          <div
            className={className('Table__row', {
              'Table__row--active': checkIds.includes(ip.id),
            })}
            key={`${ip.id}_${ip.createdAt}`}
            data-x={ip}
          >
            <div className='Table__col'>
              {renderCheckBox(ip)}
            </div>
            <div className='Table__col'>{ip.id}</div>

            <div className='Table__col'>
              <span>{ip.ipAddress}</span>
              {ip.spammer && <span className="Badge Badge--red">spam</span>}
            </div>

            <div className='Table__col'>
              <span>{ip.adminEmail}</span>
            </div>

            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: ip.createdAt !== null ?
                    moment(ip.createdAt).format('YYYY-MM-DD<br />HH:mm')
                  :
                    'N/A'
                }
              }
            />

            <div className='Table__col'>
              <div className='Table__controls'>
                {canBan('User') &&
                  <LiftBanModal
                    klassName='Table__controls__a Table__controls__a--lock-green'
                    id={ip.id}
                    reload
                    banType='ip_address'
                  />
                }
              </div>
            </div>
          </div>
        ))}
      </div>

      <Modal
        isActive={modal}
        onToggleModal={() => {
          modalSet(false)
        }}
      >
        <div className='ModeratorsModal'>
          <h3 className='Modal__h3'>Add ban IP</h3>

          <form
            className='ModeratorsModal__form'
            onSubmit={(e) => {
              e.preventDefault()
              const $els = e.target.elements
              requestCallback(axios.post(`/${gon.currentProvider}/api/banned_ips`, {
                data: {
                  ip_address: get($els, 'ipAddress.value').trim(),
                  spammer: get($els, 'spammer.checked'),
                },
                authenticity_token: CSRF_TOKEN,
              }))
            }}
          >
            <input
              type='text'
              className='Input'
              name='ipAddress'
              placeholder='IP Address'
            />

            {get(window.gon, 'currentAdmin.isSuperAdmin') &&
              <div className="ModeratorsModal__form__checkbox">
                <label className="ModeratorsModal__form__checkbox__label">
                  <input type="checkbox" name="spammer" />
                  <span className="CheckBox"></span>
                  <span>Spam</span>
                </label>
              </div>
            }

            <div className='ModeratorsModal__form__buttons'>
              <a
                className='Button Button--gray-light'
                onClick={() => {
                  modalSet(false)
                }}
              >
                Cancel
              </a>

              <button
                className='Button Button--red'
              >
                Ban
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </React.Fragment>
  );
}

export default BannedIpsList
